import { useRef } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { settleConfirm, useConfirmRequest } from '@/lib/confirm';

/** Toont de vraag van `confirmAction`; één keer gemount naast de app. */
export function ConfirmDialog() {
  const request = useConfirmRequest((state) => state.request);
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <Dialog open={!!request} onOpenChange={(open) => !open && settleConfirm(false)}>
      {request && (
        <DialogContent
          className="sm:max-w-md"
          onOpenAutoFocus={(event) => {
            // Annuleren als standaard, zodat Enter niets verwijdert.
            event.preventDefault();
            cancelRef.current?.focus();
          }}
        >
          <DialogHeader>
            <DialogTitle>{request.title}</DialogTitle>
            {request.description && <DialogDescription>{request.description}</DialogDescription>}
          </DialogHeader>
          <DialogFooter>
            <Button ref={cancelRef} variant="outline" onClick={() => settleConfirm(false)}>
              Annuleren
            </Button>
            <Button
              variant={request.destructive ? 'destructive' : 'default'}
              onClick={() => settleConfirm(true)}
            >
              {request.confirmLabel ?? 'Doorgaan'}
            </Button>
          </DialogFooter>
        </DialogContent>
      )}
    </Dialog>
  );
}
